import { useQueryState, UseQueryStateOptions } from 'nuqs'

export type QueryStateSet<T = object> = {
  [key in string | keyof T]: {
    getValue: () => any
    setValue: (value: any) => any
  }
}

export type QueryStateSetArgs = {
  [key: string]: UseQueryStateOptions<any>
}

export function useQueryStateSet<T = object>(fieldParsers: QueryStateSetArgs): [QueryStateSet<T>, T] {
  const fields = {}

  Object.keys(fieldParsers).forEach(fieldKey => {
    const queryStateItem = useQueryState(fieldKey, fieldParsers[fieldKey])

    fields[fieldKey] = {
      getValue: () => queryStateItem[0],
      setValue: (value: any) => queryStateItem[1](value),
    }
  })

  const fieldValues = {}
  Object.keys(fields).forEach(fieldKey => {
    fieldValues[fieldKey] = fields[fieldKey].getValue()
  })

  // @ts-ignore
  return [fields, fieldValues]
}
